import { connect } from "react-redux";

import {
  AirCfarExercise,
  FlightsCfarExerciseActions,
  FlightsCfarExerciseSelectors,
} from "@b2bportal/core-flights-cfar-exercise";

import { trackEvent } from "@hopper-b2b/api";
import {
  type Action,
  createSelector,
  type ThunkDispatch,
} from "@reduxjs/toolkit";

import type { IStoreState } from "../../../../../reducers/types";
import { getSelectedFlight } from "../../../../TripsList/reducer";

const mapStateToProps = createSelector(
  FlightsCfarExerciseSelectors.selectQuoteFetchState,
  FlightsCfarExerciseSelectors.selectFulfillQuoteFetchState,
  getSelectedFlight,
  (quoteFetchResource, fulfillQuoteFetchResource, selectedFlight) => ({
    quoteFetchResource,
    fulfillQuoteFetchResource,
    email: selectedFlight.emailAddress ?? "",
    trackEvent,
  })
);

const mapDispatchToProps = {
  fetchQuote:
    () =>
    (
      dispatch: ThunkDispatch<IStoreState, unknown, Action>,
      getState: () => IStoreState
    ) => {
      const flight = getSelectedFlight(getState());

      dispatch(
        FlightsCfarExerciseActions.fetchQuote({
          itineraryId: flight.bookedItinerary.id,
        })
      );
    },
  fulfillQuote: FlightsCfarExerciseActions.fulfillQuote,
  resetExercise: FlightsCfarExerciseActions.resetCfarExerciseState,
};

export const ConnectedAirCfarExercise = connect(
  mapStateToProps,
  mapDispatchToProps
)(AirCfarExercise);
